import { Box, Divider, Stack, Typography } from '@mui/material';

import { useGlobalModal } from '@/global-hooks/use-global-modal';
import CustomModal from '@/shared/components/custom-modal';

export type FundDescriptionProps = {
  fundName: string;
  fundDescription: string;
};

export const FundDescriptionModal = () => {
  const { handleClose, open, props } = useGlobalModal('FUND_DESCRIPTION_MODAL');
  return (
    <CustomModal open={open} onClose={handleClose} withCloseButton>
      <Box>
        <Stack gap="8px" alignItems="center">
          <Typography variant="h6">Description</Typography>
        </Stack>
        <Divider style={{ margin: '16px 0px 24px', borderColor: '#39455B' }} />
        <Box p="12px" bgcolor="#1B202B" border="1px solid #383A49" borderRadius="10px">
          <Typography variant="body2" sx={{ overflowWrap: 'break-word' }}>
            {props?.fundDescription}
          </Typography>
        </Box>
      </Box>
    </CustomModal>
  );
};
